import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export default function GeoPinIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 5.5C11 7.15685 9.65685 8.5 8 8.5C6.34315 8.5 5 7.15685 5 5.5C5 3.84315 6.34315 2.5 8 2.5C9.65685 2.5 11 3.84315 11 5.5ZM8.50027 9.46902C10.4733 9.22285 12 7.53972 12 5.5C12 3.29086 10.2091 1.5 8 1.5C5.79086 1.5 4 3.29086 4 5.5C4 7.5399 5.52698 9.22316 7.50027 9.46909L7.50027 14C7.50027 14.2761 7.72413 14.5 8.00027 14.5C8.27641 14.5 8.50027 14.2761 8.50027 14V9.46902Z"
        fill="#1E1E1E"
      />
    </SvgIcon>
  );
}
